module.exports = __webpack_public_path__ + "img/beginner.32e24b1d.png";